import { ProductItem, Section } from './models';
import * as api from './api';

const sectionRequest = async (menuGuid, sectionGuid) => {
  // If it's a clause (sectionGuid is null), currentSection is null and we fetch the entire list
  // otherwise we get the currentSection directly and use its children as the list
  let section;
  if (sectionGuid) {
    const response = await api.sectionRequest(sectionGuid);
    section = new Section(response.data);
  } else {
    const response = await api.sectionRequest('', menuGuid, 1);
    section = new Section({
      guid: Section.CLAUSE_LIST_GUID,
      type: Section.CLAUSE_LIST_TYPE,
      sections: Section.toInstanceList(response.data.results)
    });
  }
  const sectionList = section.sections;
  return { section, sectionList };
};

export const getSection = async (menuGuid, sectionGuid) => {
  const { section, sectionList } = await sectionRequest(menuGuid, sectionGuid);
  return { section, sectionList };
};

export const breadCrumbRequest = async (getSectionByGuid, section) => {
  let newSection = null;
  let newClause = null;
  if (section && section.parent_section) {
    const foundClause = getSectionByGuid(section.parent_section);
    newClause = foundClause || new Section((await api.sectionRequest(section.parent_section)).data);
    if (newClause.parent_section) {
      // If newClause has a parent, it's a section, not a clause, so we find the real clause
      const foundSec = getSectionByGuid(newClause.parent_section);
      newSection = newClause;
      newClause = foundSec || new Section((await api.sectionRequest(newClause.parent_section)).data);
    }
  }
  return { newClause, newSection };
};

export const reorderItems = async (oldItemsList, newItemsList) => {
  newItemsList.forEach((item, index) => {
    // Only sends API calls for items whose order actually changed
    if (oldItemsList[index] !== newItemsList[index]) {
      item.order = index;
      if (item instanceof ProductItem) api.editProductRequest(item.guid, item);
      else api.editSectionRequest(item.guid, item.serialize());
    }
  });
};

export const moveItem = async (currentSection, currentSectionList, item, value) => {
  const editedItem = item instanceof ProductItem ? new ProductItem(item) : new Section(item);
  const swappedItem = currentSectionList.find((sec) => sec.order === (item.order + value))
    || currentSection.products.find((sec) => sec.order === (item.order + value));
  const editedSwappedItem = swappedItem instanceof ProductItem ? new ProductItem(swappedItem) : new Section(swappedItem);

  [editedItem.order, editedSwappedItem.order] = [editedSwappedItem.order, editedItem.order];

  if (editedItem instanceof ProductItem) await api.editProductRequest(editedItem.guid, editedItem);
  else await api.editSectionRequest(editedItem.guid, editedItem);
  if (editedSwappedItem instanceof ProductItem) await api.editProductRequest(editedSwappedItem.guid, editedSwappedItem);
  else await api.editSectionRequest(editedSwappedItem.guid, editedSwappedItem);
  return { item, swappedItem };
};
